import React from 'react'
import {Route, Routes} from "react-router-dom"
import Form from '../pages/Form/Form'
import Resume from '../pages/Resume/Resume'
const Routing = () => {
  return (
    <>
    <Routes>
        <Route path="/" element={<Form />}/>
        <Route path='/resume' element={<Resume />}/>
    </Routes>
    </>
  )
}

export default Routing